export default __webpack_public_path__ + "static/media/chris-ensminger-i6yrDhfZ-XQ-unsplash.d81e331b.jpg";